
import { BaseModel, Form, EntryTypes, Entry, TwoColumnLayout, Resource } from '@ngx-resource-toolkit/core';
import { environment } from '../../../../environments/environment';
import { FormGroup } from '@angular/forms';
import { LeaResource } from '../../resource/lea.resource';

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/famille',
            methods: LeaResource.methods,
        }
    }
})
@Form({
    'search': {
        layout: TwoColumnLayout,
        onChanges: (value: FamilleRechercheModel, form: FormGroup) => {
            const nom: string = form.value['nom'];
            const nomResponsable: string = form.value['nomResponsable'];
            if (nom) {
                form.patchValue({nom: nom.toUpperCase()},  {emitEvent: false});
            }
            if (nomResponsable) {
                form.patchValue({nomResponsable: nomResponsable.toUpperCase()}, {emitEvent: false});
            }
        }
    }
})
export class FamilleRechercheModel extends BaseModel {

    @Entry({
        'search': {
            hidden: true
        }
    })
    _explicitType: string = "FamilleSearchCriteria";

    @Entry({
        'search': {
            hidden: true
        }
    })
    anneeScolaire: string;

    @Entry({
        'search': {
            type: EntryTypes.NUMBER,
            css: {
                group: 'col-xs-6',
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            placeholder: 'Numéro',
            label: 'N°',
            layout: 'left'
        }
    })
    id: number;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            css: { group: 'col-xs-6'},
            options: [{
                label: 'Inclure anciennes familles',
                value: true
            }],
            layout: 'left',
        }
    })
    avecFamillesInactives: boolean;

    @Entry({
        'search': {
            type: EntryTypes.TEXT,
            css: {
                group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            label: 'Nom',
            placeholder: 'Nom',
            layout: 'left',
        }
    })
    nom: string;

    @Entry({
        'search': {
            type: EntryTypes.TEXT,
            css: {
                group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            label: 'Email',
            placeholder: 'Email',
            layout: 'left',
        }
    })
    email: string;

    @Entry({
        'search': {
            type: EntryTypes.TEXT,
            css: {
                group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            label: 'Responsable',
            placeholder: 'Responsable',
            layout: 'right'
        }
    })
    nomResponsable: string;

    @Entry({
        'search': {
            type: EntryTypes.TEXT,
            css: {
                group: 'col-xs-12',
                label: 'col-xs-2',
                input: 'col-xs-10'
            },
            label: 'Téléphone',
            placeholder: 'Téléphone',
            layout: 'right'
        }
    })
    telephone: string;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-6 col-lg-3',
                // label: 'col-lg-1 col-xs-2',
                // input: 'col-xs-2 checkbox-inline'
            },
            options: [{
                value: true,
                label: 'Avec dettes'
            }],
            layout: 'center',
        }
    })
    isFamilleAvecDette: boolean;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-6 col-lg-3',
                // label: 'col-lg-1 col-xs-2',
                // input: 'col-xs-2 checkbox-inline'
            },
            options: [{
                value: true,
                    label: 'Avec trop perçu'
            }],
            layout: 'center',
        }
    })
    isFamilleAvecTropPercu: boolean;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-6 col-lg-3',
                // label: 'col-lg-1 col-xs-2',
                // input: 'col-xs-2 checkbox-inline'
            },
            options: [{
                value: true,
                    label: 'Sans paiement'
            }],
            layout: 'center',
        }
    })
    isFamilleSansPaiement: boolean;

    @Entry({
        'search': {
            type: EntryTypes.CHECKBOX,
            css: {
                group: 'col-xs-6 col-lg-3',
                // label: 'col-lg-1 col-xs-2',
                // input: 'checkbox-inline'
            },
            options: [{
                value: 1,
                label: 'Avec cours'
            }],
            layout: 'center',
        }
    })
    isAvecInscription: boolean;

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/famille/models/famille-recherche.model.ts